import React from "react";
import AppContainer from "./components/AppContainer";
import { BrowserRouter } from "react-router-dom";
import Router from "./components/routes";
import { ScrollToTop } from "react-router-scroll-to-top";

function App(props: any) {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <AppContainer {...props}>
        <Router />
      </AppContainer>
    </BrowserRouter>
  );
}

export default App;
